import React from "react";

export const TrainingContext = React.createContext({
  onToggleTrainingModal: () => {}
});



// WEBPACK FOOTER //
// ./src/contexts/training.js